(function () {
  const root = document.querySelector('[data-duetras-collection]');
  const dataNode = document.getElementById('DuetrasCollectionData');
  if (!root || !dataNode) return;

  let products = [];
  try {
    products = JSON.parse(dataNode.textContent);
  } catch (error) {
    return;
  }

  const wearLayout = root.getAttribute('data-layout') === 'wear';
  const SIZES = wearLayout
    ? {
        all: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
        men: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
        women: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
        kids: ['2–3', '4–5', '6–7', '8–9', '10–12'],
      }
    : {
        men: ['6', '7', '8', '9', '10', '11'],
        women: ['3', '4', '5', '6', '7', '8'],
        kids: ['10', '11', '12', '13', '1', '2', '3', '4', '5'],
      };

  const state = {
    dept: 'all',
    genders: [],
    families: [],
    type: 'all',
    size: '',
    colors: [],
    min: '',
    max: '',
    stock: false,
    sort: 'price-desc',
    group: '',
    shown: 12,
  };

  const genderNames = { men: 'Male', women: 'Female', kids: 'Kids' };
  const params = new URLSearchParams(window.location.search);
  const dept = params.get('dept');
  if (wearLayout && dept) {
    state.genders = dept.split(',').filter((item) => item === 'men' || item === 'women' || item === 'kids');
  } else if (dept === 'men' || dept === 'women' || dept === 'kids') {
    state.dept = dept;
  }
  if (params.get('family')) state.families = params.get('family').split(',').filter(Boolean);
  if (params.get('size')) state.size = params.get('size');
  if (!wearLayout && params.get('color')) state.colors = params.get('color').split(',').filter(Boolean);
  if (params.get('min')) state.min = params.get('min');
  if (params.get('max')) state.max = params.get('max');
  if (params.get('stock') === '1') state.stock = true;
  if (params.get('sort')) state.sort = params.get('sort');
  if (params.get('group')) state.group = params.get('group');
  const wearType = params.get('type');
  if (wearType) state.type = wearType;

  const grid = root.querySelector('[data-duetras-grid]');
  const count = root.querySelector('[data-duetras-count]');
  const empty = root.querySelector('[data-duetras-empty]');
  const more = root.querySelector('[data-duetras-more]');
  const pills = root.querySelector('[data-duetras-pills]');
  const sizeBox = root.querySelector('[data-duetras-sizes]');
  const sizeNote = root.querySelector('[data-duetras-size-note]');
  const colourBox = root.querySelector('[data-duetras-colours]');
  const kidsNote = root.querySelector('[data-duetras-kids]');
  const editorial = document.getElementById('DuetrasEditorial');
  const sort = root.querySelector('[data-duetras-sort]');
  const minInput = root.querySelector('[data-price="min"]');
  const maxInput = root.querySelector('[data-price="max"]');
  const minLabel = root.querySelector('[data-price-min-label]');
  const maxLabel = root.querySelector('[data-price-max-label]');
  const priceFill = root.querySelector('[data-price-fill]');
  const stockInput = root.querySelector('[data-stock]');

  const esc = (value) =>
    String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const colourList = [];
  products.forEach((product) => {
    (product.colors || []).forEach((color) => {
      if (!colourList.includes(color)) colourList.push(color);
    });
  });

  if (colourBox) {
    colourBox.innerHTML = colourList
      .map(
        (color) =>
          `<button type="button" class="duetras-colour" data-color="${esc(color)}" aria-pressed="false" aria-label="${esc(color)}"><span class="duetras-swatch" data-color="${esc(color.toLowerCase())}"></span></button>`
      )
      .join('');
  }

  const writeUrl = () => {
    const next = new URLSearchParams();
    const view = new URLSearchParams(window.location.search).get('view');
    if (view) next.set('view', view);
    if (wearLayout) {
      if (state.genders.length) next.set('dept', state.genders.join(','));
    } else if (state.dept !== 'all') {
      next.set('dept', state.dept);
    }
    if (state.families.length) next.set('family', state.families.join(','));
    if (state.size && (state.dept !== 'all' || wearLayout)) next.set('size', state.size);
    if (state.colors.length) next.set('color', state.colors.join(','));
    if (state.min) next.set('min', state.min);
    if (state.max) next.set('max', state.max);
    if (state.stock) next.set('stock', '1');
    if (state.sort && state.sort !== 'price-desc') next.set('sort', state.sort);
    if (state.group) next.set('group', state.group);
    if (state.type && state.type !== 'all') next.set('type', state.type);
    const query = next.toString();
    window.history.replaceState(null, '', query ? `${window.location.pathname}?${query}` : window.location.pathname);
  };

  const productDepts = (product) =>
    product.depts && product.depts.length ? product.depts : product.dept ? [product.dept] : [];

  const wordMatch = (haystack, needle) => {
    const escaped = needle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp(`(?:^|[^a-z0-9])${escaped}(?:[^a-z0-9]|$)`).test(haystack || '');
  };

  const matchesType = (product, type) => {
    if ((product.types || []).includes(type)) return true;
    const hay = product.haystack || '';
    if (type === 'headgear') return wordMatch(hay, 'headgear') || wordMatch(hay, 'head-gear') || hay.includes('head gear');
    if (type === 'upper' || type === 'lower' || type === 'traditional' || type === 'other' || type === 'others') return wordMatch(hay, type);
    return hay.includes(type);
  };

  const filtered = () => {
    let items = products.slice();
    if (wearLayout && state.genders.length) {
      items = items.filter((product) => state.genders.some((gender) => productDepts(product).includes(gender)));
    } else if (state.dept !== 'all') {
      items = items.filter((product) => productDepts(product).includes(state.dept));
    }
    if (state.type !== 'all') {
      items = items.filter((product) => matchesType(product, state.type));
    }
    if (state.families.length) items = items.filter((product) => state.families.includes(product.family));
    if (state.size && (wearLayout || state.dept !== 'all')) {
      items = items.filter((product) => (product.sizes || []).includes(state.size));
    }
    if (state.colors.length) {
      const wanted = state.colors.map((color) => color.toLowerCase());
      items = items.filter((product) =>
        (product.colors || []).some((color) => wanted.includes(color.toLowerCase()))
      );
    }
    const min = state.min === '' ? null : Number(state.min) * 100;
    const max = state.max === '' ? null : Number(state.max) * 100;
    if (min !== null && !Number.isNaN(min)) items = items.filter((product) => product.price >= min);
    if (max !== null && !Number.isNaN(max)) items = items.filter((product) => product.price <= max);
    if (state.stock) items = items.filter((product) => product.available);
    if (state.group) {
      const needle = state.group.toLowerCase().replace(/-/g, ' ');
      items = items.filter((product) => (product.haystack || '').includes(needle));
    }
    if (state.sort === 'price-asc') items.sort((a, b) => a.price - b.price);
    else if (state.sort === 'price-desc') items.sort((a, b) => b.price - a.price);
    else if (state.sort === 'title') items.sort((a, b) => a.title.localeCompare(b.title));
    else items.sort((a, b) => a.index - b.index);
    return items;
  };

  const deptNames = (depts) => {
    const names = [];
    if (depts.includes('men')) names.push('Men');
    if (depts.includes('women')) names.push('Women');
    if (depts.includes('kids')) names.push('Kids');
    return names.join(' · ');
  };

  const cardHtml = (product) => {
    const depts = product.depts && product.depts.length ? product.depts : product.dept ? [product.dept] : [];
    const meta = [product.familyLabel, product.deptLabel || deptNames(depts)].filter(Boolean).join(' · ');
    const image = product.image
      ? `<img class="duetras-card__image" src="${esc(product.image)}" alt="${esc(product.title)}" loading="lazy" width="800" height="1000">`
      : '';
    const hover = product.hover
      ? `<img class="duetras-card__image duetras-card__image--hover" src="${esc(product.hover)}" alt="" loading="lazy" width="800" height="1000">`
      : '';
    const swatches = (product.colors || [])
      .slice(0, 4)
      .map(
        (color) =>
          `<span class="duetras-swatch" data-color="${esc(color.toLowerCase())}" title="${esc(color)}"></span>`
      )
      .join('');
    return `<a class="duetras-card" href="${esc(product.url)}">
      <div class="duetras-card__media">${image}${hover}</div>
      <div>
        <p class="duetras-card__title">${esc(product.title)}</p>
        ${meta ? `<p class="duetras-card__meta">${esc(meta)}</p>` : ''}
        <p class="duetras-card__price">${
          product.available
            ? `${esc(product.priceLabel)}${
                product.compareAt > product.price
                  ? `<s class="duetras-card__compare">${esc(product.compareLabel)}</s><span class="duetras-sale-tag">Sale</span>`
                  : ''
              }`
            : 'Sold out'
        }</p>
        ${swatches ? `<div class="duetras-card__swatches">${swatches}</div>` : ''}
      </div>
    </a>`;
  };

  const wearSizes = () => {
    const onlyKids = state.genders.length === 1 && state.genders[0] === 'kids';
    if (onlyKids) return SIZES.kids.slice();
    const sizes = SIZES.all.slice();
    if (state.genders.includes('kids')) {
      SIZES.kids.forEach((size) => {
        if (!sizes.includes(size)) sizes.push(size);
      });
    }
    return sizes;
  };

  const renderSizes = () => {
    if (!sizeBox || !sizeNote) return;
    if (!wearLayout && state.dept === 'all') {
      sizeBox.innerHTML = '';
      sizeNote.textContent = 'Choose Men, Women or Kids to filter by size.';
      return;
    }
    const sizes = wearLayout ? wearSizes() : SIZES[state.dept] || SIZES.all || [];
    if (state.size && !sizes.includes(state.size)) state.size = '';
    sizeBox.innerHTML = sizes
      .map(
        (size) =>
          `<button type="button" data-size="${esc(size)}" aria-pressed="${state.size === size ? 'true' : 'false'}">${esc(size)}</button>`
      )
      .join('');
    if (wearLayout) {
      const onlyKids = state.genders.length === 1 && state.genders[0] === 'kids';
      if (onlyKids) {
        sizeNote.textContent = 'Shown for Kids by age: 2 to 3, 4 to 5, 6 to 7, 8 to 9, 10 to 12.';
      } else if (!state.genders.length) {
        sizeNote.textContent =
          'Shown for Male and Female (XS to XXL). Kids by age: 2 to 3, 4 to 5, 6 to 7, 8 to 9, 10 to 12. Choose Male, Female or Kids to filter by size.';
      } else {
        sizeNote.textContent = 'Shown for Male and Female (XS to XXL). Kids by age: 2 to 3, 4 to 5, 6 to 7, 8 to 9, 10 to 12.';
      }
      return;
    }
    const lead = state.dept.charAt(0).toUpperCase() + state.dept.slice(1);
    const range = state.dept === 'kids' ? 'UK 10 to 5' : `UK ${sizes[0]} to ${sizes[sizes.length - 1]}`;
    const rest = {
      men: 'Women UK 3 to 8, Kids UK 10 to 5.',
      women: 'Men UK 6 to 11, Kids UK 10 to 5.',
      kids: 'Men UK 6 to 11, Women UK 3 to 8.',
    };
    sizeNote.textContent = `Shown for ${lead} (${range}). ${rest[state.dept]}`;
  };

  const renderPills = () => {
    if (!pills) return;
    const bits = [];
    state.families.forEach((family) => {
      const label = family.charAt(0).toUpperCase() + family.slice(1);
      bits.push(`<button type="button" class="duetras-pill" data-clear="family" data-value="${esc(family)}">${esc(label)} ×</button>`);
    });
    if (state.size && (wearLayout || state.dept !== 'all')) {
      bits.push(`<button type="button" class="duetras-pill" data-clear="size">${esc(state.size)} ×</button>`);
    }
    if (state.type !== 'all') {
      const label = state.type.charAt(0).toUpperCase() + state.type.slice(1);
      bits.push(`<button type="button" class="duetras-pill" data-clear="type">${esc(label)} ×</button>`);
    }
    state.genders.forEach((gender) => {
      bits.push(
        `<button type="button" class="duetras-pill" data-clear="gender" data-value="${esc(gender)}">${esc(genderNames[gender] || gender)} ×</button>`
      );
    });
    state.colors.forEach((color) => {
      bits.push(`<button type="button" class="duetras-pill" data-clear="color" data-value="${esc(color)}">${esc(color)} ×</button>`);
    });
    if (state.min || state.max) {
      const { floor, ceiling } = priceBounds();
      const label = `₹${state.min || floor}–₹${state.max || ceiling}`;
      bits.push(`<button type="button" class="duetras-pill" data-clear="price">${esc(label)} ×</button>`);
    }
    if (state.stock) bits.push('<button type="button" class="duetras-pill" data-clear="stock">In stock ×</button>');
    if (state.group) {
      const label = state.group.replace(/-/g, ' ');
      bits.push(`<button type="button" class="duetras-pill" data-clear="group">${esc(label)} ×</button>`);
    }
    if (bits.length) bits.push('<button type="button" class="duetras-clear" data-clear="all">Clear all</button>');
    pills.innerHTML = bits.join('');
    pills.hidden = bits.length === 0;
  };

  const priceBounds = () => {
    const prices = products
      .map((product) => Math.round(Number(product.price) / 100))
      .filter((price) => Number.isFinite(price));
    if (!prices.length) return { floor: 0, ceiling: 0 };
    return { floor: Math.min(...prices), ceiling: Math.max(...prices) };
  };

  const paintPrice = () => {
    if (!minInput || !maxInput) return;
    const { floor, ceiling } = priceBounds();
    minInput.min = String(floor);
    minInput.max = String(ceiling);
    maxInput.min = String(floor);
    maxInput.max = String(ceiling);
    let low = state.min === '' ? floor : Number(state.min);
    let high = state.max === '' ? ceiling : Number(state.max);
    if (!Number.isFinite(low)) low = floor;
    if (!Number.isFinite(high)) high = ceiling;
    low = Math.min(Math.max(low, floor), ceiling);
    high = Math.min(Math.max(high, floor), ceiling);
    if (low > high) low = high;
    minInput.value = String(low);
    maxInput.value = String(high);
    if (minLabel) minLabel.textContent = `₹ ${low}`;
    if (maxLabel) maxLabel.textContent = `₹ ${high}`;
    if (priceFill) {
      const span = ceiling - floor;
      const start = span > 0 ? ((low - floor) / span) * 100 : 0;
      const end = span > 0 ? ((high - floor) / span) * 100 : 100;
      priceFill.style.insetInlineStart = `${start}%`;
      priceFill.style.insetInlineEnd = `${100 - end}%`;
    }
  };

  const readPrice = (source) => {
    if (!minInput || !maxInput) return;
    const { floor, ceiling } = priceBounds();
    let low = Number(minInput.value);
    let high = Number(maxInput.value);
    if (source === minInput && low > high) {
      low = high;
      minInput.value = String(low);
    }
    if (source === maxInput && high < low) {
      high = low;
      maxInput.value = String(high);
    }
    state.min = low <= floor ? '' : String(low);
    state.max = high >= ceiling ? '' : String(high);
    apply();
  };

  const syncControls = () => {
    root.querySelectorAll('[data-dept]').forEach((tab) => {
      tab.setAttribute('aria-selected', tab.getAttribute('data-dept') === state.dept ? 'true' : 'false');
    });
    root.querySelectorAll('[data-type]').forEach((tab) => {
      tab.setAttribute('aria-selected', tab.getAttribute('data-type') === state.type ? 'true' : 'false');
    });
    root.querySelectorAll('[data-gender]').forEach((input) => {
      input.checked = state.genders.includes(input.value);
    });
    root.querySelectorAll('[data-family]').forEach((input) => {
      input.checked = state.families.includes(input.value);
    });
    if (sort) sort.value = state.sort;
    paintPrice();
    if (stockInput) stockInput.checked = state.stock;
    if (kidsNote) kidsNote.hidden = wearLayout ? false : state.dept !== 'kids';
    colourBox?.querySelectorAll('[data-color]').forEach((button) => {
      button.setAttribute('aria-pressed', state.colors.includes(button.getAttribute('data-color')) ? 'true' : 'false');
    });
    renderSizes();
  };

  const render = () => {
    const items = filtered();
    const visible = items.slice(0, state.shown);
    if (count) {
      const noun = root.getAttribute('data-noun') || '';
      count.textContent = `Showing ${visible.length} of ${items.length}${noun}`;
    }
    if (empty) {
      empty.hidden = items.length !== 0;
      empty.textContent = products.length === 0 ? 'Nothing here yet.' : 'Nothing matches those filters.';
    }
    if (grid) {
      grid.innerHTML = visible.map(cardHtml).join('');
      if (editorial && items.length) {
        const spot = document.createElement('div');
        spot.appendChild(editorial.content.cloneNode(true));
        const node = spot.firstElementChild;
        const after = Math.min(6, visible.length);
        const card = grid.children[after - 1];
        if (card) card.insertAdjacentElement('afterend', node);
        else grid.appendChild(node);
      }
    }
    if (more) more.hidden = visible.length >= items.length;
    renderPills();
    scheduleFill();
  };

  let filling = false;

  const scheduleFill = () => {
    if (!more || filling) return;
    filling = true;
    const step = () => {
      if (!more || more.hidden) {
        filling = false;
        return;
      }
      const rect = more.getBoundingClientRect();
      const items = filtered();
      if (rect.top > window.innerHeight + 640 || state.shown >= items.length) {
        filling = false;
        return;
      }
      state.shown = Math.min(state.shown + 12, items.length);
      render();
      requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  const apply = () => {
    state.shown = 12;
    syncControls();
    render();
    writeUrl();
  };

  root.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-dept]');
    if (tab) {
      event.preventDefault();
      state.dept = tab.getAttribute('data-dept');
      apply();
      return;
    }
    const typeTab = event.target.closest('[data-type]');
    if (typeTab) {
      event.preventDefault();
      state.type = typeTab.getAttribute('data-type');
      apply();
      return;
    }
    const sizeButton = event.target.closest('[data-size]');
    if (sizeButton) {
      const size = sizeButton.getAttribute('data-size');
      state.size = state.size === size ? '' : size;
      apply();
      return;
    }
    const colour = event.target.closest('.duetras-colour');
    if (colour) {
      const color = colour.getAttribute('data-color');
      state.colors = state.colors.includes(color)
        ? state.colors.filter((item) => item !== color)
        : state.colors.concat(color);
      apply();
      return;
    }
    const clear = event.target.closest('[data-clear]');
    if (clear) {
      const kind = clear.getAttribute('data-clear');
      const value = clear.getAttribute('data-value');
      if (kind === 'family') state.families = state.families.filter((item) => item !== value);
      else if (kind === 'gender') state.genders = state.genders.filter((item) => item !== value);
      else if (kind === 'type') state.type = 'all';
      else if (kind === 'size') state.size = '';
      else if (kind === 'color') state.colors = state.colors.filter((item) => item !== value);
      else if (kind === 'price') {
        state.min = '';
        state.max = '';
      } else if (kind === 'stock') state.stock = false;
      else if (kind === 'group') state.group = '';
      else if (kind === 'all') {
        state.families = [];
        state.genders = [];
        state.type = 'all';
        state.size = '';
        state.colors = [];
        state.min = '';
        state.max = '';
        state.stock = false;
        state.group = '';
        state.dept = 'all';
        state.sort = 'price-desc';
      }
      apply();
      return;
    }
    if (event.target.closest('[data-duetras-more]')) {
      const items = filtered();
      state.shown = Math.min(state.shown + 12, items.length);
      render();
    }
  });

  if (more && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) scheduleFill();
      },
      { rootMargin: '640px 0px' }
    );
    observer.observe(more);
  } else if (more) {
    window.addEventListener('scroll', () => scheduleFill(), { passive: true });
    window.addEventListener('resize', () => scheduleFill());
  }

  root.addEventListener('change', (event) => {
    const family = event.target.closest('[data-family]');
    if (family) {
      state.families = Array.from(root.querySelectorAll('[data-family]:checked')).map((input) => input.value);
      apply();
      return;
    }
    if (event.target.matches('[data-gender]')) {
      state.genders = Array.from(root.querySelectorAll('[data-gender]:checked')).map((input) => input.value);
      if (state.size) {
        const sizes = wearSizes();
        if (!sizes.includes(state.size)) state.size = '';
      }
      apply();
      return;
    }
    if (event.target.matches('[data-duetras-sort]')) {
      state.sort = event.target.value;
      apply();
    }
    if (event.target.matches('[data-stock]')) {
      state.stock = event.target.checked;
      apply();
    }
  });

  const addGender = (value, into) => {
    const visit = (item) => {
      if (item == null) return;
      if (Array.isArray(item)) {
        item.forEach(visit);
        return;
      }
      if (typeof item === 'object') {
        Object.values(item).forEach(visit);
        return;
      }
      const raw = String(item).trim().toLowerCase();
      if (!raw) return;
      if (/[,|/]/.test(raw)) {
        raw.split(/[,|/]/).forEach((part) => visit(part));
        return;
      }
      if (raw === 'male' || raw === 'men' || raw === 'man' || raw === 'him') into.add('men');
      else if (raw === 'female' || raw === 'women' || raw === 'woman' || raw === 'her') into.add('women');
      else if (raw === 'unisex' || raw === 'both') {
        into.add('men');
        into.add('women');
      } else if (raw === 'kids' || raw === 'kid' || raw === 'child' || raw === 'children') into.add('kids');
    };
    visit(value);
  };

  const loadDepartments = () => {
    const read = (path) =>
      fetch(path)
        .then((response) => (response.ok ? response.json() : { products: [] }))
        .catch(() => ({ products: [] }));
    return Promise.all([
      read('/collections/for-him/products.json?limit=50'),
      read('/collections/for-her/products.json?limit=50'),
      read('/collections/kids/products.json?limit=50'),
    ]).then(([him, her, kids]) => {
      const men = new Set((him.products || []).map((product) => product.handle));
      const women = new Set((her.products || []).map((product) => product.handle));
      const child = new Set((kids.products || []).map((product) => product.handle));
      products.forEach((product) => {
        const depts = new Set(product.depts || (product.dept ? [product.dept] : []));
        addGender(product.gender, depts);
        if (product.handle && men.has(product.handle)) depts.add('men');
        if (product.handle && women.has(product.handle)) depts.add('women');
        if (product.handle && child.has(product.handle)) depts.add('kids');
        product.depts = [...depts].filter(Boolean);
        product.deptLabel = deptNames(product.depts);
      });
    });
  };

  if (minInput && maxInput) {
    minInput.addEventListener('pointerdown', () => {
      minInput.style.zIndex = '4';
      maxInput.style.zIndex = '3';
    });
    maxInput.addEventListener('pointerdown', () => {
      maxInput.style.zIndex = '4';
      minInput.style.zIndex = '3';
    });
    minInput.addEventListener('input', () => readPrice(minInput));
    maxInput.addEventListener('input', () => readPrice(maxInput));
  }

  loadDepartments().then(() => {
    syncControls();
    render();
  });
})();
